/**
 * Course UI copy. English is the source file; any interface or course language
 * can add `src/i18n/locales/<lang>/pages/sections/course.json` and override it.
 */
import { existsSync, readFileSync } from "node:fs";
import { join } from "node:path";
import { sharedScriptLocale } from './script/shared-copy.js';

const cache = new Map();

function readCourseFile(lang) {
  const file = join(process.cwd(), `src/i18n/locales/${lang}/pages/sections/course.json`);
  if (!existsSync(file)) return null;
  return JSON.parse(readFileSync(file, "utf8"));
}

function mergeCopy(base, extra) {
  if (!extra) return base;
  const merged = { ...base, ...extra };
  for (const key of ["personTraits", "units", "kinds", "sections", "ui"]) {
    if (extra[key] && typeof extra[key] === "object") {
      merged[key] = { ...(base[key] || {}), ...extra[key] };
    }
  }
  return merged;
}

/** @param {string} [lang] interface language, or a course language for on-page strings */
export function courseCopy(lang = "en") {
  const code = String(lang || "en").trim().toLowerCase() || "en";
  if (cache.has(code)) return cache.get(code);
  const english = readCourseFile("en") || {};
  const merged = code === "en" ? { ...english } : mergeCopy(english, readCourseFile(code));
  merged.ui = { ...merged.ui, ...sharedScriptLocale('en').ui, ...sharedScriptLocale(code).ui };
  cache.set(code, merged);
  return merged;
}

/** Shared rendered labels; English keys stay readable to editors. */
export function courseUiText(key, uiLang = "en", values = {}) {
  const text = courseCopy(uiLang).ui?.[key] || key;
  return text.replace(/\{(\w+)\}/g, (_, name) => values[name] ?? "{" + name + "}");
}
